import React, { Component } from "react";

class ImageSpacer extends Component {
  render() {
    return <div className="image-spacer"></div>;
  }
}

export default ImageSpacer;
